import styled from 'styled-components'

import LAYOUT from 'constants/layout'
import MEDIA from 'constants/media'
import FONTS from 'constants/fonts'
import COLORS from 'constants/colors'

import { RelatedPostsProps } from './types'

export const Post = styled.div`
  margin: 120px 20px ${LAYOUT.VERTICALSPACE};
  max-width: 800px;
  img {
    max-width: 100%;
  }
  ${MEDIA.medium`
  margin: 180px auto ${LAYOUT.VERTICALSPACE} ;
  `}
`

export const PostImage = styled.div`
  margin-bottom: 10px;
  img {
    width: 100%;
    max-width: 800px;
  }
`

export const PostTitle = styled.div`
  h1 {
    font-size: ${FONTS.TITLETWO};
    text-align: center;
    margin-bottom: 20px;
  }
`

export const PostDate = styled.div`
  margin-bottom: 30px;
  text-align: center;
`

export const PostNavigation = styled.div`
  background: ${COLORS.LIGHTYELLOW};
  margin-bottom: 30px;
  font-size: ${FONTS.PARAGRAPHMEDIUM};
  font-family: ${FONTS.FAMILYSECONDARY};
  font-weight: ${FONTS.WEIGHTDEMI};
  padding: 40px 20px;
  > div {
    display: flex;
    justify-content: space-between;
    max-width: 1280px;
    margin: auto;
    a:link, a:visited {
      text-decoration: none;
    }
  }
`

export const RelatedPosts = styled.div<RelatedPostsProps>`
  display: ${props => props.show ? 'flex' : 'none'};
  margin: ${LAYOUT.VERTICALSPACEMOBILE} 0;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  padding: 0 10px;
  h2 {
    font-size: ${FONTS.TITLETWO};
    width: 100%;
    text-align: center;
    margin-top: 0;
  }
  ${MEDIA.medium`
    margin: ${LAYOUT.VERTICALSPACEMOBILE} auto ${LAYOUT.VERTICALSPACE} ;
  `}
`
